import { makeStyles } from '@material-ui/core/styles'
import { isDarkColor } from '@v4/utils'

const useStyles = makeStyles(
	theme => ({
		root: {},
		radio: {
			color: theme.palette.text.secondary,
			backgroundColor: 'transparent !important',
			'& svg': {
				width: 26,
				height: 26,
			},
			'& div': {
				backgroundColor: theme.palette.getContrastText(theme.palette.text.secondary),
				borderRadius: '50%',
			},
			padding: 6,
		},
		checked: {
			'& svg:nth-child(2)': {
				fill: theme.palette.primary.main,
			},
		},
		control: {
			margin: 0,
			'& input:focus ~ div svg:first-child path': {
				stroke: isDarkColor(theme.palette.primary.main)
					? theme.palette.primary.light
					: theme.palette.primary.dark,
				strokeWidth: 1,
			},
		},
		label: {
			textShadow: ({ shadow }) => (shadow ? theme.palette.textShadow : null),
			display: 'flex',
			alignItems: 'center',
		},
	}),
	{ name: 'Questions-AnswerTypes-OldRadioButton' },
)

export default useStyles
